import { Content } from '@/lib';
import styles from './Spacer.module.scss';

interface SpacerProps {
  type: Content.Type.spacer | Content.Type.spacerS | Content.Type.spacerL;
}
export function Spacer({ type }: SpacerProps) {
  return <div className={styles[type]} />;
}
